export function isPayMeUrl(url: string) {
  try {
    const u = new URL(url)
    return (
      u.hostname.endsWith('paymebiz.hsbc.com.hk')
      || u.hostname.endsWith('payme.hsbc.com.hk')
      || u.hostname.endsWith('mobsandboxprod.paymebiz.hsbc.com.hk')
    )
  }
  catch {
    return false
  }
}
